import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ImageBlock, ImageBlockDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getImage(id: string): Observable<ImageBlock> {
        return this.httpClient.get<ImageBlockDto>(`library/images/${id}`).pipe(mapDto((data) => new ImageBlock(data)));
    }
}
